// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.baseModal {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 99999;
  transition: opacity 1s ease-in;
  pointer-events: auto;
  overflow-y: auto;
}
.baseModalPosition {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: transparent;
}
.deleteConfirmModal {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: transparent;
  width: 400px;
  height: 300px;
}
.roomChangeModal {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: transparent;
  width: 700px;
  height: 600px;
}
.availableRoleModal {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: transparent;
  width: 500px;
}
.siteListModal {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: transparent;
  width: 600px;
  max-width: 700px;
  overflow-y: scroll;
}
.createGroupModal {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: transparent;
  width: 400px;
  height: 300px;
}
.reviewMsgModal {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: transparent;
  width: 1000px;
  max-height: 500px;
}
.verifyPwModal {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: transparent;
  width: 300px;
  height: 300px;
}
.roomStatModal {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: transparent;
  width: 800px;
  height: 500px;
}
.emailModalSize {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: transparent;
  width: 500px;
  height: 400px;
}
.CategoryModal {
  width: 410px;
  margin: 200px 750px;
}
.eventsIterationModal {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: transparent;
  width: 600px;
  max-height: 500px;
}
table tbody {
  display: table-row-group;
}
#cornerRadius .leftTop3 {
  -moz-border-radius-topleft: 3px;
  -webkit-border-top-left-radius: 3px;
  border-top-left-radius: 3px;
}
#cornerRadius .leftBottom3 {
  -moz-border-radius-bottomleft: 3px;
  -webkit-border-bottom-left-radius: 3px;
  border-bottom-left-radius: 3px;
}
#cornerRadius .rightTop3 {
  -moz-border-radius-topright: 3px;
  -webkit-border-top-right-radius: 3px;
  border-top-right-radius: 3px;
}
#cornerRadius .rightBottom3 {
  -moz-border-radius-bottomright: 3px;
  -webkit-border-bottom-right-radius: 3px;
  border-bottom-right-radius: 3px;
}
#cornerRadius .all3 {
  -moz-border-radius-topleft: 3px;
  -webkit-border-top-left-radius: 3px;
  border-top-left-radius: 3px;
  -moz-border-radius-bottomleft: 3px;
  -webkit-border-bottom-left-radius: 3px;
  border-bottom-left-radius: 3px;
  -moz-border-radius-topright: 3px;
  -webkit-border-top-right-radius: 3px;
  border-top-right-radius: 3px;
  -moz-border-radius-bottomright: 3px;
  -webkit-border-bottom-right-radius: 3px;
  border-bottom-right-radius: 3px;
}
#cornerRadius .leftTop5 {
  -moz-border-radius-topleft: 5px;
  -webkit-border-top-left-radius: 5px;
  border-top-left-radius: 5px;
}
#cornerRadius .leftBottom5 {
  -moz-border-radius-bottomleft: 5px;
  -webkit-border-bottom-left-radius: 5px;
  border-bottom-left-radius: 5px;
}
#cornerRadius .rightTop5 {
  -moz-border-radius-topright: 5px;
  -webkit-border-top-right-radius: 5px;
  border-top-right-radius: 5px;
}
#cornerRadius .rightBottom5 {
  -moz-border-radius-bottomright: 5px;
  -webkit-border-bottom-right-radius: 5px;
  border-bottom-right-radius: 5px;
}
#cornerRadius .all5 {
  -moz-border-radius-topleft: 5px;
  -webkit-border-top-left-radius: 5px;
  border-top-left-radius: 5px;
  -moz-border-radius-bottomleft: 5px;
  -webkit-border-bottom-left-radius: 5px;
  border-bottom-left-radius: 5px;
  -moz-border-radius-topright: 5px;
  -webkit-border-top-right-radius: 5px;
  border-top-right-radius: 5px;
  -moz-border-radius-bottomright: 5px;
  -webkit-border-bottom-right-radius: 5px;
  border-bottom-right-radius: 5px;
}
#cornerRadius .leftTop10 {
  -moz-border-radius-topleft: 10px;
  -webkit-border-top-left-radius: 10px;
  border-top-left-radius: 10px;
}
#cornerRadius .leftBottom10 {
  -moz-border-radius-bottomleft: 10px;
  -webkit-border-bottom-left-radius: 10px;
  border-bottom-left-radius: 10px;
}
#cornerRadius .rightTop10 {
  -moz-border-radius-topright: 10px;
  -webkit-border-top-right-radius: 10px;
  border-top-right-radius: 10px;
}
#cornerRadius .rightBottom10 {
  -moz-border-radius-bottomright: 10px;
  -webkit-border-bottom-right-radius: 10px;
  border-bottom-right-radius: 10px;
}
#cornerRadius .leftSide10 {
  -moz-border-radius-topleft: 10px;
  -webkit-border-top-left-radius: 10px;
  border-top-left-radius: 10px;
  -moz-border-radius-bottomleft: 10px;
  -webkit-border-bottom-left-radius: 10px;
  border-bottom-left-radius: 10px;
}
#cornerRadius .rightSide10 {
  -moz-border-radius-topright: 10px;
  -webkit-border-top-right-radius: 10px;
  border-top-right-radius: 10px;
  -moz-border-radius-bottomright: 10px;
  -webkit-border-bottom-right-radius: 10px;
  border-bottom-right-radius: 10px;
}
#cornerRadius .all10 {
  -moz-border-radius-topleft: 10px;
  -webkit-border-top-left-radius: 10px;
  border-top-left-radius: 10px;
  -moz-border-radius-bottomleft: 10px;
  -webkit-border-bottom-left-radius: 10px;
  border-bottom-left-radius: 10px;
  -moz-border-radius-topright: 10px;
  -webkit-border-top-right-radius: 10px;
  border-top-right-radius: 10px;
  -moz-border-radius-bottomright: 10px;
  -webkit-border-bottom-right-radius: 10px;
  border-bottom-right-radius: 10px;
}
.ts-2 {
  font-size: 1.2em;
}
.jumbotron {
  margin: 0 3px;
}
.hdricon img {
  height: 56px;
}
.left-spacer-10 {
  padding-left: 10px;
}
.left-margin-10 {
  margin-left: 10px;
}
.right-margin-5 {
  margin-right: 5px;
}
.pagination {
  margin-bottom: 0;
}
.paginationWBtn {
  padding-top: 7px;
}
.paginationWBtn2 {
  padding-top: 0;
}
.requiredField {
  color: "red";
  font-size: 2em;
  line-height: 20px;
  vertical-align: middle;
}
.thf {
  font-size: 0.8em;
}
.thfc {
  font-size: 0.8em;
  text-align: center;
}
.thsort {
  text-decoration: underline;
  cursor: pointer;
}
.tdf {
  font-size: 0.7em;
  line-height: 22px;
  vertical-align: bottom;
}
.docDesc {
  font-size: 0.9em;
}
.tdf-lg-c {
  text-align: center;
}
.tdfc {
  font-size: 0.7em;
  line-height: 22px;
  vertical-align: bottom;
  text-align: center;
}
.trselectable {
  cursor: pointer;
}
.alertClass {
  color: red;
}
i {
  border: solid black;
  border-width: 0 3px 3px 0;
  display: inline-block;
  padding: 3px;
}
.up {
  transform: rotate(-135deg);
  -webkit-transform: rotate(-135deg);
}
.down {
  transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
}
.nav-link {
  cursor: pointer;
}
.navHeader {
  text-align: center;
  font-size: 1.3em;
  font-weight: bold;
  padding: 3px;
}
.fixed {
  position: fixed;
}
.relative {
  position: relative;
}
.footer {
  bottom: 0;
  left: 0;
  right: 0;
  height: 50px;
  padding: 5px;
  line-height: 40px;
  vertical-align: middle;
  font-size: 0.7em;
}
.fixedfooter {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 50px;
  padding: 5px;
  line-height: 40px;
  vertical-align: middle;
  font-size: 0.7em;
  background-color: #e4f2f8;
}
.relativefooter {
  position: relative;
  bottom: 0;
  left: 0;
  right: 0;
  height: 50px;
  padding: 5px;
  line-height: 40px;
  vertical-align: middle;
  font-size: 0.7em;
}
.disabledLabel {
  font-size: 0.8em;
  color: #cccccc;
}
.enabledLabel {
  font-size: 0.8em;
}
.radioOpts {
  margin: 0 0.5em 0 1em;
  padding: 0;
}
.rdoLabel {
  margin: 0;
}
.tableexport {
  position: absolute;
  display: block;
}
.siteexport {
  position: relative;
  top: 0;
  left: 0;
}
.siteexportexcel {
  position: relative;
  top: 0;
  left: 150px;
}
.paginationSelect {
  height: 30px;
}
.msgGroupNone {
  padding-left: 40px;
  font-size: 0.8em;
}
.selectableColumn {
  color: #1f60c4;
  text-decoration: underline;
  cursor: pointer;
}
.table-narrow {
  display: inline-table;
  width: 250px;
  margin: 10px;
}
.table-lessnarrow {
  display: inline-table;
  width: 350px;
  margin: 10px;
}
.rowGrid {
  display: -ms-webkit-box;
  /* IE 10 */
  display: -webkit-box;
  -ms-flex-wrap: wrap;
  /* IE 10 */
  flex-wrap: wrap;
  padding: 0 4px;
}
/* Create two equal columns that sits next to each other */
.columnGrid {
  -ms-flex: 50%;
  /* IE 10 */
  flex: 20%;
  padding: 0 4px;
  text-align: center;
}
.column img {
  margin-top: 8px;
  vertical-align: middle;
}
button.desc {
  background-color: #007bff;
  padding: 3px 20px;
  margin: 5px;
  vertical-align: unset;
}
img.docView {
  border: none;
  outline: none;
  padding: 5px 10px;
  background-color: #f1f1f1;
  cursor: pointer;
}
img.docView:hover {
  background-color: #ddd;
}
.siteListHidden {
  position: relative;
  top: 10px;
  left: 20px;
  width: 28px;
  display: inline-flex;
  z-index: 10;
}
.siteSideList {
  position: absolute;
  top: 150px;
  left: 20px;
  width: 230px;
  height: auto;
  max-height: 400px;
  font-size: 0.8em;
  border: 1px solid #efefef;
  border-radius: 5px;
  -moz-border-radius-topleft: 5px;
  -webkit-border-top-left-radius: 5px;
  border-top-left-radius: 5px;
  -moz-border-radius-bottomleft: 5px;
  -webkit-border-bottom-left-radius: 5px;
  border-bottom-left-radius: 5px;
  -moz-border-radius-topright: 5px;
  -webkit-border-top-right-radius: 5px;
  border-top-right-radius: 5px;
  -moz-border-radius-bottomright: 5px;
  -webkit-border-bottom-right-radius: 5px;
  border-bottom-right-radius: 5px;
}
.siteSideList #siteSideList td {
  padding: 2px;
}
.siteSideList #siteSideList tbody tr:hover {
  background-color: #efefef;
}
.siteSideList #siteSideList thead {
  display: block;
}
.siteSideList #siteSideList tbody {
  display: block;
  height: 280px;
  overflow-y: auto;
}
.siteSideListSm {
  position: absolute;
  top: 20%;
  left: 20px;
  width: 230px;
  height: auto;
  max-height: 400px;
  font-size: 0.8em;
  border: 1px solid #efefef;
  border-radius: 5px;
  -moz-border-radius-topleft: 5px;
  -webkit-border-top-left-radius: 5px;
  border-top-left-radius: 5px;
  -moz-border-radius-bottomleft: 5px;
  -webkit-border-bottom-left-radius: 5px;
  border-bottom-left-radius: 5px;
  -moz-border-radius-topright: 5px;
  -webkit-border-top-right-radius: 5px;
  border-top-right-radius: 5px;
  -moz-border-radius-bottomright: 5px;
  -webkit-border-bottom-right-radius: 5px;
  border-bottom-right-radius: 5px;
  transform: translateY(-20%);
}
.siteSideListSm #siteSideList td {
  padding: 2px;
}
.siteSideListSm #siteSideList tbody tr:hover {
  background-color: #efefef;
}
.siteSideListSm #siteSideList thead {
  display: block;
}
.siteSideListSm #siteSideList tbody {
  display: block;
  height: 280px;
  overflow-y: auto;
}
.siteDataRow {
  width: 90%;
}
.status-image {
  height: 20px;
}
/* STYLES FOR MESSAGING */
#message .d-inline-block {
  vertical-align: top;
}
.roomlistContainer {
  width: 245px;
  height: auto;
  margin-top: 1em;
  border: 1px solid #0006cc;
  border-radius: 5px;
  -moz-border-radius-topleft: 5px;
  -webkit-border-top-left-radius: 5px;
  border-top-left-radius: 5px;
  -moz-border-radius-bottomleft: 5px;
  -webkit-border-bottom-left-radius: 5px;
  border-bottom-left-radius: 5px;
  -moz-border-radius-topright: 5px;
  -webkit-border-top-right-radius: 5px;
  border-top-right-radius: 5px;
  -moz-border-radius-bottomright: 5px;
  -webkit-border-bottom-right-radius: 5px;
  border-bottom-right-radius: 5px;
  padding: 3px;
}
.roomlistContainer-sm {
  width: 245px;
  height: auto;
  margin-top: 1em;
  border: 1px solid #0006cc;
  border-radius: 5px;
  -moz-border-radius-topleft: 5px;
  -webkit-border-top-left-radius: 5px;
  border-top-left-radius: 5px;
  -moz-border-radius-bottomleft: 5px;
  -webkit-border-bottom-left-radius: 5px;
  border-bottom-left-radius: 5px;
  -moz-border-radius-topright: 5px;
  -webkit-border-top-right-radius: 5px;
  border-top-right-radius: 5px;
  -moz-border-radius-bottomright: 5px;
  -webkit-border-bottom-right-radius: 5px;
  border-bottom-right-radius: 5px;
  padding: 3px;
  width: 140px;
}
.roomlist {
  font-size: 0.8em;
  height: auto;
}
.roomlist thead {
  display: block;
  border-bottom: 1px solid #0006cc;
}
.roomlist tbody {
  display: block;
  height: auto;
  max-height: 450px;
  overflow-y: scroll;
}
.roomlistSelected {
  background-color: #999999;
}
.groupListContainer {
  display: block;
  width: 200px;
  margin-top: 1em;
  margin-left: 0.75em;
}
.groupselect {
  min-width: 150px;
  font-size: 11px;
}
.addcontrolsContainer {
  display: block;
  margin-top: 3em;
  margin-left: 0.75em;
  text-align: center;
}
.addControl {
  font-size: 24px;
  cursor: pointer;
}
.addControlText {
  font-size: 18px;
  cursor: pointer;
}
.baseAreaContainers {
  margin-top: 1em;
  margin-left: 0.75em;
  -moz-border-radius-topleft: 5px;
  -webkit-border-top-left-radius: 5px;
  border-top-left-radius: 5px;
  -moz-border-radius-bottomleft: 5px;
  -webkit-border-bottom-left-radius: 5px;
  border-bottom-left-radius: 5px;
  -moz-border-radius-topright: 5px;
  -webkit-border-top-right-radius: 5px;
  border-top-right-radius: 5px;
  -moz-border-radius-bottomright: 5px;
  -webkit-border-bottom-right-radius: 5px;
  border-bottom-right-radius: 5px;
  padding: 3px;
  border: 1px solid #0006cc;
  border-radius: 5px;
  font-size: 0.95em;
}
.baseAreaHdr {
  margin-bottom: 5px;
  text-align: center;
  border-bottom: 1px solid #0006cc;
}
.priorityContainer {
  margin-top: 1em;
  margin-left: 0.75em;
  -moz-border-radius-topleft: 5px;
  -webkit-border-top-left-radius: 5px;
  border-top-left-radius: 5px;
  -moz-border-radius-bottomleft: 5px;
  -webkit-border-bottom-left-radius: 5px;
  border-bottom-left-radius: 5px;
  -moz-border-radius-topright: 5px;
  -webkit-border-top-right-radius: 5px;
  border-top-right-radius: 5px;
  -moz-border-radius-bottomright: 5px;
  -webkit-border-bottom-right-radius: 5px;
  border-bottom-right-radius: 5px;
  padding: 3px;
  border: 1px solid #0006cc;
  border-radius: 5px;
  font-size: 0.95em;
  width: 160px;
  height: 132px;
  display: inline-block;
  vertical-align: top;
}
.responseContainer {
  margin-top: 1em;
  margin-left: 0.75em;
  -moz-border-radius-topleft: 5px;
  -webkit-border-top-left-radius: 5px;
  border-top-left-radius: 5px;
  -moz-border-radius-bottomleft: 5px;
  -webkit-border-bottom-left-radius: 5px;
  border-bottom-left-radius: 5px;
  -moz-border-radius-topright: 5px;
  -webkit-border-top-right-radius: 5px;
  border-top-right-radius: 5px;
  -moz-border-radius-bottomright: 5px;
  -webkit-border-bottom-right-radius: 5px;
  border-bottom-right-radius: 5px;
  padding: 3px;
  border: 1px solid #0006cc;
  border-radius: 5px;
  font-size: 0.95em;
  width: 270px;
  display: inline-block;
  vertical-align: top;
}
.expireContainer {
  margin-top: 1em;
  margin-left: 0.75em;
  -moz-border-radius-topleft: 5px;
  -webkit-border-top-left-radius: 5px;
  border-top-left-radius: 5px;
  -moz-border-radius-bottomleft: 5px;
  -webkit-border-bottom-left-radius: 5px;
  border-bottom-left-radius: 5px;
  -moz-border-radius-topright: 5px;
  -webkit-border-top-right-radius: 5px;
  border-top-right-radius: 5px;
  -moz-border-radius-bottomright: 5px;
  -webkit-border-bottom-right-radius: 5px;
  border-bottom-right-radius: 5px;
  padding: 3px;
  border: 1px solid #0006cc;
  border-radius: 5px;
  font-size: 0.95em;
  width: 612px;
}
.missiveContainer {
  margin-top: 1em;
  margin-left: 0.75em;
  -moz-border-radius-topleft: 5px;
  -webkit-border-top-left-radius: 5px;
  border-top-left-radius: 5px;
  -moz-border-radius-bottomleft: 5px;
  -webkit-border-bottom-left-radius: 5px;
  border-bottom-left-radius: 5px;
  -moz-border-radius-topright: 5px;
  -webkit-border-top-right-radius: 5px;
  border-top-right-radius: 5px;
  -moz-border-radius-bottomright: 5px;
  -webkit-border-bottom-right-radius: 5px;
  border-bottom-right-radius: 5px;
  padding: 3px;
  border: 1px solid #0006cc;
  border-radius: 5px;
  font-size: 0.95em;
  width: 612px;
}
.missiveText {
  width: 604px;
}
.grpMgrSection {
  margin-bottom: 10px;
}
.grpMgrAction {
  font-size: 12px;
  cursor: pointer;
}
.expiretime {
  font-size: 0.7em;
  margin-left: 1em;
}
.msgReviewContent {
  font-size: 0.8em;
}
.msgReviewGenDiv {
  display: inline-flex;
  font-size: 0.8em;
}
.msgReviewGenDiv:not(:last-child) {
  margin-right: 2em;
}
/*.msgReviewDetailList {
  min-height:80px;
  max-height:300px;
  overflow-y:scroll;
}*/
/* END STYLES FOR MESSAGING */
/* Text Token Styles*/
.text-token-page-container {
  display: flex;
  box-sizing: border-box;
}
.text-token-list-container {
  flex-basis: 50%;
}
.text-token-editor-container {
  flex-basis: 50%;
}
.textTokenRow {
  height: 57px;
}
/* END STYLES FOR Text Tokens */
`, "",{"version":3,"sources":["webpack://./src/styles/modal.less","webpack://./src/styles/site.less","webpack://./src/styles/common.less"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,oCAAA;EACA,cAAA;EACA,8BAAA;EACA,oBAAA;EACA,gBAAA;ACCF;ADEA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,6BAAA;ACAF;ADGA;EAPE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,6BAAA;EAKA,YAAA;EACA,aAAA;ACGF;ADAA;EAbE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,6BAAA;EAWA,YAAA;EACA,aAAA;ACMF;ADHA;EAnBE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,6BAAA;EAiBA,YAAA;ACSF;ADNA;EAxBE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,6BAAA;EAsBA,YAAA;EACA,gBAAA;EACA,kBAAA;ACYF;ADTA;EA/BE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,6BAAA;EA6BA,YAAA;EACA,aAAA;ACeF;ADZA;EArCE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,6BAAA;EAmCA,aAAA;EACA,iBAAA;ACkBF;ADfA;EA3CE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,6BAAA;EAyCA,YAAA;EACA,aAAA;ACqBF;ADlBA;EAjDE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,6BAAA;EA+CA,YAAA;EACA,aAAA;ACwBF;ADrBA;EAvDE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,6BAAA;EAqDA,YAAA;EACA,aAAA;AC2BF;ADxBA;EAEE,YAAA;EACE,mBAAA;ACyBJ;ADtBA;EAnEE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,6BAAA;EAiEA,YAAA;EACA,iBAAA;AC4BF;AC9GA;EACE,wBAAA;ADgHF;AC7GA;EAEI,+BAAA;EACA,mCAAA;EACA,2BAAA;AD8GJ;AClHA;EAOI,kCAAA;EACA,sCAAA;EACA,8BAAA;AD8GJ;ACvHA;EAYI,gCAAA;EACA,oCAAA;EACA,4BAAA;AD8GJ;AC5HA;EAiBI,mCAAA;EACA,uCAAA;EACA,+BAAA;AD8GJ;ACjIA;EAEI,+BAAA;EACA,mCAAA;EACA,2BAAA;EAGA,kCAAA;EACA,sCAAA;EACA,8BAAA;EAGA,gCAAA;EACA,oCAAA;EACA,4BAAA;EAGA,mCAAA;EACA,uCAAA;EACA,+BAAA;AD4HJ;AC/IA;EA4BI,+BAAA;EACA,mCAAA;EACA,2BAAA;ADsHJ;ACpJA;EAiCI,kCAAA;EACA,sCAAA;EACA,8BAAA;ADsHJ;ACzJA;EAsCI,gCAAA;EACA,oCAAA;EACA,4BAAA;ADsHJ;AC9JA;EA2CI,mCAAA;EACA,uCAAA;EACA,+BAAA;ADsHJ;ACnKA;EA4BI,+BAAA;EACA,mCAAA;EACA,2BAAA;EAGA,kCAAA;EACA,sCAAA;EACA,8BAAA;EAGA,gCAAA;EACA,oCAAA;EACA,4BAAA;EAGA,mCAAA;EACA,uCAAA;EACA,+BAAA;ADoIJ;ACjLA;EAsDI,gCAAA;EACA,oCAAA;EACA,4BAAA;AD8HJ;ACtLA;EA2DI,mCAAA;EACA,uCAAA;EACA,+BAAA;AD8HJ;AC3LA;EAgEI,iCAAA;EACA,qCAAA;EACA,6BAAA;AD8HJ;AChMA;EAqEI,oCAAA;EACA,wCAAA;EACA,gCAAA;AD8HJ;ACrMA;EAsDI,gCAAA;EACA,oCAAA;EACA,4BAAA;EAGA,mCAAA;EACA,uCAAA;EACA,+BAAA;ADgJJ;AC7MA;EAgEI,iCAAA;EACA,qCAAA;EACA,6BAAA;EAGA,oCAAA;EACA,wCAAA;EACA,gCAAA;AD8IJ;ACrNA;EAsDI,gCAAA;EACA,oCAAA;EACA,4BAAA;EAGA,mCAAA;EACA,uCAAA;EACA,+BAAA;EAGA,iCAAA;EACA,qCAAA;EACA,6BAAA;EAGA,oCAAA;EACA,wCAAA;EACA,gCAAA;AD4JJ;AC5IA;EACE,gBAAA;AD8IF;AC3IA;EACE,aAAA;AD6IF;AC1IA;EACE,YAAA;AD4IF;ACzIA;EACE,kBAAA;AD2IF;ACzIA;EACE,iBAAA;AD2IF;ACxIA;EACE,iBAAA;AD0IF;ACxIA;EACE,gBAAA;AD0IF;ACxIA;EACE,gBAAA;AD0IF;ACxIA;EACE,cAAA;AD0IF;ACvIA;EACE,YAAA;EACA,cAAA;EACA,iBAAA;EACA,sBAAA;ADyIF;ACtIA;EACE,gBAAA;ADwIF;ACtIA;EAFE,gBAAA;EAIA,kBAAA;ADwIF;ACtIA;EACE,0BAAA;EACA,eAAA;ADwIF;ACtIA;EACE,gBAAA;EACA,iBAAA;EACA,sBAAA;ADwIF;ACtIA;EACE,gBAAA;ADwIF;ACtIA;EACE,kBAAA;ADwIF;ACtIA;EAVE,gBAAA;EACA,iBAAA;EACA,sBAAA;EAUA,kBAAA;AD0IF;ACxIA;EACE,eAAA;AD0IF;ACxIA;EAEE,UAAA;ADyIF;ACtIA;EACI,mBAAA;EACA,yBAAA;EACA,qBAAA;EACA,YAAA;ADwIJ;ACtIA;EACE,0BAAA;EACA,kCAAA;ADwIF;ACtIA;EACE,wBAAA;EACA,gCAAA;ADwIF;ACrIA;EACE,eAAA;ADuIF;ACrIA;EACE,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,YAAA;ADuIF;ACrIA;EACE,eAAA;ADuIF;ACrIA;EACE,kBAAA;ADuIF;ACrIA;EACE,SAAA;EACA,OAAA;EACA,QAAA;EACA,YAAA;EACA,YAAA;EACA,iBAAA;EACA,sBAAA;EACA,gBAAA;ADuIF;ACrIA;EAfE,eAAA;EAMA,SAAA;EACA,OAAA;EACA,QAAA;EACA,YAAA;EACA,YAAA;EACA,iBAAA;EACA,sBAAA;EACA,gBAAA;EAKA,yBAAA;AD8IF;AC5IA;EAjBE,kBAAA;EAGA,SAAA;EACA,OAAA;EACA,QAAA;EACA,YAAA;EACA,YAAA;EACA,iBAAA;EACA,sBAAA;EACA,gBAAA;AD8JF;AClJA;EACE,gBAAA;EACA,cAAA;ADoJF;AClJA;EACE,gBAAA;ADoJF;ACjJA;EACE,qBAAA;EACA,UAAA;ADmJF;ACjJA;EACE,SAAA;ADmJF;AChJA;EACE,kBAAA;EACA,cAAA;ADkJF;AC/IA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;ADiJF;AC/IA;EACE,kBAAA;EACA,MAAA;EACA,WAAA;ADiJF;AC/IA;EACE,YAAA;ADiJF;AC/IA;EACE,kBAAA;EACA,gBAAA;ADiJF;AC9IA;EACE,cAAA;EACA,0BAAA;EACA,eAAA;ADgJF;AC7IA;EACE,qBAAA;EACA,YAAA;EACA,YAAA;AD+IF;AC7IA;EACE,qBAAA;EACA,YAAA;EACA,YAAA;AD+IF;AC1IA;EACE,uBAAA;ED4IA,UAAU;EC3IV,oBAAA;EACA,mBAAA;ED6IA,UAAU;EC5IV,eAAA;EACA,cAAA;AD8IF;AACA,0DAA0D;AC3I1D;EACE,aAAA;ED6IA,UAAU;EC5IV,SAAA;EACA,cAAA;EACA,kBAAA;AD8IF;AC3IA;EACE,eAAA;EACA,sBAAA;AD6IF;AC1IA;EACE,yBAAA;EACA,iBAAA;EACA,WAAA;EACA,qBAAA;AD4IF;ACzIA;EACE,YAAA;EACA,aAAA;EACA,iBAAA;EACA,yBAAA;EACA,eAAA;AD2IF;ACvIA;EACE,sBAAA;ADyIF;AA/bA;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,oBAAA;EACA,WAAA;AAicF;AA9bA;EACE,kBAAA;EACA,UAAA;EACA,UAAA;EACA,YAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;ECcE,+BAAA;EACA,mCAAA;EACA,2BAAA;EAGA,kCAAA;EACA,sCAAA;EACA,8BAAA;EAGA,gCAAA;EACA,oCAAA;EACA,4BAAA;EAGA,mCAAA;EACA,uCAAA;EACA,+BAAA;AD6aJ;AAzcA;EAAiC,YAAA;AA4cjC;AA3cA;EACE,yBAAA;AA6cF;AA3cA;EACE,cAAA;AA6cF;AA3cA;EACE,cAAA;EACA,aAAA;EACA,gBAAA;AA6cF;AA1cA;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,YAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;ECXE,+BAAA;EACA,mCAAA;EACA,2BAAA;EAGA,kCAAA;EACA,sCAAA;EACA,8BAAA;EAGA,gCAAA;EACA,oCAAA;EACA,4BAAA;EAGA,mCAAA;EACA,uCAAA;EACA,+BAAA;EDJF,2BAAA;AAudF;AArdA;EAAmC,YAAA;AAwdnC;AAvdA;EACE,yBAAA;AAydF;AAvdA;EACE,cAAA;AAydF;AAvdA;EACE,cAAA;EACA,aAAA;EACA,gBAAA;AAydF;AAtdA;EACE,UAAA;AAwdF;AArdA;EACE,YAAA;AAudF;AACA,yBAAyB;AApdzB;EACE,mBAAA;AAsdF;AApdA;EACE,YAAA;EACA,YAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;EC7CE,+BAAA;EACA,mCAAA;EACA,2BAAA;EAGA,kCAAA;EACA,sCAAA;EACA,8BAAA;EAGA,gCAAA;EACA,oCAAA;EACA,4BAAA;EAGA,mCAAA;EACA,uCAAA;EACA,+BAAA;ED8BF,YAAA;AAieF;AA/dA;EARE,YAAA;EACA,YAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;EC7CE,+BAAA;EACA,mCAAA;EACA,2BAAA;EAGA,kCAAA;EACA,sCAAA;EACA,8BAAA;EAGA,gCAAA;EACA,oCAAA;EACA,4BAAA;EAGA,mCAAA;EACA,uCAAA;EACA,+BAAA;ED8BF,YAAA;EAIA,YAAA;AAkfF;AAhfA;EACE,gBAAA;EACA,YAAA;AAkfF;AAhfA;EACE,cAAA;EACA,gCAAA;AAkfF;AAhfA;EACE,cAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;AAkfF;AAhfA;EACE,yBAAA;AAkfF;AA/eA;EACE,cAAA;EACA,YAAA;EACA,eAAA;EACA,mBAAA;AAifF;AA/eA;EACE,gBAAA;EACA,eAAA;AAifF;AA9eA;EACE,cAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;AAgfF;AA9eA;EACE,eAAA;EACA,eAAA;AAgfF;AA9eA;EACE,eAAA;EACA,eAAA;AAgfF;AA7eA;EACE,eAAA;EACA,mBAAA;ECnGE,+BAAA;EACA,mCAAA;EACA,2BAAA;EAGA,kCAAA;EACA,sCAAA;EACA,8BAAA;EAGA,gCAAA;EACA,oCAAA;EACA,4BAAA;EAGA,mCAAA;EACA,uCAAA;EACA,+BAAA;EDoFF,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;AA0fF;AAxfA;EACE,kBAAA;EACA,kBAAA;EACA,gCAAA;AA0fF;AAxfA;EAbE,eAAA;EACA,mBAAA;ECnGE,+BAAA;EACA,mCAAA;EACA,2BAAA;EAGA,kCAAA;EACA,sCAAA;EACA,8BAAA;EAGA,gCAAA;EACA,oCAAA;EACA,4BAAA;EAGA,mCAAA;EACA,uCAAA;EACA,+BAAA;EDoFF,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;EASA,YAAA;EACA,aAAA;EACA,qBAAA;EACA,mBAAA;AA2gBF;AAxgBA;EArBE,eAAA;EACA,mBAAA;ECnGE,+BAAA;EACA,mCAAA;EACA,2BAAA;EAGA,kCAAA;EACA,sCAAA;EACA,8BAAA;EAGA,gCAAA;EACA,oCAAA;EACA,4BAAA;EAGA,mCAAA;EACA,uCAAA;EACA,+BAAA;EDoFF,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;EAiBA,YAAA;EACA,qBAAA;EACA,mBAAA;AA2hBF;AAxhBA;EA5BE,eAAA;EACA,mBAAA;ECnGE,+BAAA;EACA,mCAAA;EACA,2BAAA;EAGA,kCAAA;EACA,sCAAA;EACA,8BAAA;EAGA,gCAAA;EACA,oCAAA;EACA,4BAAA;EAGA,mCAAA;EACA,uCAAA;EACA,+BAAA;EDoFF,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;EAwBA,YAAA;AA2iBF;AAxiBA;EAjCE,eAAA;EACA,mBAAA;ECnGE,+BAAA;EACA,mCAAA;EACA,2BAAA;EAGA,kCAAA;EACA,sCAAA;EACA,8BAAA;EAGA,gCAAA;EACA,oCAAA;EACA,4BAAA;EAGA,mCAAA;EACA,uCAAA;EACA,+BAAA;EDoFF,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;EA6BA,YAAA;AA2jBF;AAzjBA;EACE,YAAA;AA2jBF;AAxjBA;EACE,mBAAA;AA0jBF;AAxjBA;EACE,eAAA;EACA,eAAA;AA0jBF;AAvjBA;EACE,gBAAA;EACA,gBAAA;AAyjBF;AAtjBA;EACE,gBAAA;AAwjBF;AAtjBA;EACE,oBAAA;EACA,gBAAA;AAwjBF;AAtjBA;EACE,iBAAA;AAwjBF;AACA;;;;EAIE;AACF,6BAA6B;AAC7B,qBAAqB;AApjBrB;EACE,aAAA;EACA,sBAAA;AAsjBF;AAnjBA;EACE,eAAA;AAqjBF;AAljBA;EACE,eAAA;AAojBF;AAjjBA;EACE,YAAA;AAmjBF;AACA,+BAA+B","sourcesContent":[".baseModal {\n  position: fixed;\n  top:0;\n  right:0;\n  bottom:0;\n  left:0;\n  background-color: rgba(0, 0, 0, 0.8);\n  z-index: 99999;\n  transition: opacity 1s ease-in;\n  pointer-events: auto;\n  overflow-y: auto;\n}\n\n.baseModalPosition {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  background-color: transparent;\n}\n\n.deleteConfirmModal {\n  .baseModalPosition;\n  width: 400px;\n  height: 300px;\n}\n\n.roomChangeModal {\n  .baseModalPosition;\n  width: 700px;\n  height: 600px;\n}\n\n.availableRoleModal {\n  .baseModalPosition;\n  width:500px;\n}\n\n.siteListModal {\n  .baseModalPosition;\n  width:600px;\n  max-width: 700px;\n  overflow-y: scroll;\n}\n\n.createGroupModal {\n  .baseModalPosition;\n  width:400px;\n  height:300px;\n}\n\n.reviewMsgModal {\n  .baseModalPosition;\n  width: 1000px;\n  max-height: 500px;\n}\n\n.verifyPwModal {\n  .baseModalPosition;\n  width: 300px;\n  height: 300px;\n}\n\n.roomStatModal {\n  .baseModalPosition;\n  width: 800px;\n  height: 500px;\n}\n\n.emailModalSize {\n  .baseModalPosition;\n  width: 500px;\n  height: 400px;\n}\n\n.CategoryModal\n{\n  width: 410px;\n    margin: 200px 750px;\n}\n\n.eventsIterationModal {\n  .baseModalPosition;\n  width: 600px;\n  max-height: 500px;\n}\n","@import 'common';\n\n.siteListHidden {\n  position: relative;\n  top:10px;\n  left:20px;\n  width:28px;\n  display: inline-flex;\n  z-index: 10;\n}\n\n.siteSideList{\n  position: absolute;\n  top: 150px;\n  left: 20px;\n  width: 230px;\n  height: auto;\n  max-height: 400px;\n  font-size: .8em;\n  border: 1px solid #efefef;\n  border-radius: 5px;\n  #cornerRadius > .all5;\n}\n.siteSideList #siteSideList td { padding: 2px }\n.siteSideList #siteSideList tbody tr:hover {\n  background-color: #efefef;\n}\n.siteSideList #siteSideList thead {\n  display: block;\n}\n.siteSideList #siteSideList tbody {\n  display: block;\n  height:280px;\n  overflow-y: auto;\n}\n\n.siteSideListSm{\n  position: absolute;\n  top: 20%;\n  left: 20px;\n  width: 230px;\n  height: auto;\n  max-height: 400px;\n  font-size: .8em;\n  border: 1px solid #efefef;\n  border-radius: 5px;\n  #cornerRadius > .all5;\n  transform: translateY(-20%);\n}\n.siteSideListSm #siteSideList td { padding: 2px }\n.siteSideListSm #siteSideList tbody tr:hover {\n  background-color: #efefef;\n}\n.siteSideListSm #siteSideList thead {\n  display: block;\n}\n.siteSideListSm #siteSideList tbody {\n  display: block;\n  height:280px;\n  overflow-y: auto;\n}\n\n.siteDataRow {\n  width:90%;\n}\n\n.status-image {\n  height:20px;\n}\n\n/* STYLES FOR MESSAGING */\n#message .d-inline-block {\n  vertical-align: top;\n}\n.roomlistContainer {\n  width:245px;\n  height:auto;\n  margin-top: 1em;\n  border: 1px solid #0006cc;\n  border-radius: 5px;\n  #cornerRadius > .all5;\n  padding:3px;\n}\n.roomlistContainer-sm {\n  .roomlistContainer;\n  width:140px;\n}\n.roomlist {\n  font-size: .8em;\n  height:auto;\n}\n.roomlist thead {\n  display: block;\n  border-bottom: 1px solid #0006cc;\n}\n.roomlist tbody {\n  display: block;\n  height: auto;\n  max-height: 450px;\n  overflow-y: scroll;\n}\n.roomlistSelected {\n  background-color: #999999;\n}\n\n.groupListContainer {\n  display: block;\n  width:200px;\n  margin-top: 1em;\n  margin-left: .75em;\n}\n.groupselect {\n  min-width:150px;\n  font-size: 11px;\n}\n\n.addcontrolsContainer {\n  display: block;\n  margin-top: 3em;\n  margin-left: .75em;\n  text-align: center;\n}\n.addControl {\n  font-size: 24px;\n  cursor: pointer;\n}\n.addControlText {\n  font-size: 18px;\n  cursor: pointer;\n}\n\n.baseAreaContainers {\n  margin-top: 1em;\n  margin-left: .75em;\n  #cornerRadius > .all5;\n  padding:3px;\n  border: 1px solid #0006cc;\n  border-radius: 5px;\n  font-size: .95em;\n}\n.baseAreaHdr {\n  margin-bottom: 5px;\n  text-align: center;\n  border-bottom: 1px solid #0006cc;\n}\n.priorityContainer {\n  .baseAreaContainers;\n  width:160px;\n  height:132px;\n  display: inline-block;\n  vertical-align: top;\n}\n\n.responseContainer {\n  .baseAreaContainers;\n  width:270px;\n  display: inline-block;\n  vertical-align: top;\n}\n\n.expireContainer {\n  .baseAreaContainers;\n  width:612px;\n}\n\n.missiveContainer {\n  .baseAreaContainers;\n  width:612px;\n}\n.missiveText {\n  width: 604px;\n}\n\n.grpMgrSection {\n  margin-bottom: 10px;\n}\n.grpMgrAction {\n  font-size: 12px;\n  cursor: pointer;\n}\n\n.expiretime {\n  font-size: .7em;\n  margin-left: 1em;\n}\n\n.msgReviewContent {\n  font-size: .8em;\n}\n.msgReviewGenDiv {\n  display: inline-flex;\n  font-size: .8em;\n}\n.msgReviewGenDiv:not(:last-child) {\n  margin-right: 2em;\n}\n/*.msgReviewDetailList {\n  min-height:80px;\n  max-height:300px;\n  overflow-y:scroll;\n}*/\n/* END STYLES FOR MESSAGING */\n\n/* Text Token Styles*/\n\n.text-token-page-container {\n  display:flex;\n  box-sizing: border-box;\n}\n\n.text-token-list-container {\n  flex-basis:50%\n}\n\n.text-token-editor-container {\n  flex-basis:50%\n}\n\n.textTokenRow{\n  height: 57px\n}\n\n/* END STYLES FOR Text Tokens */","@import \"modal\";\n\ntable tbody {\n  display: table-row-group;\n}\n\n#cornerRadius {\n  .leftTop3 {\n    -moz-border-radius-topleft:3px;\n    -webkit-border-top-left-radius:3px;\n    border-top-left-radius:3px;\n  }\n  .leftBottom3 {\n    -moz-border-radius-bottomleft:3px;\n    -webkit-border-bottom-left-radius:3px;\n    border-bottom-left-radius:3px;\n  }\n  .rightTop3 {\n    -moz-border-radius-topright: 3px;\n    -webkit-border-top-right-radius:3px;\n    border-top-right-radius:3px;\n  }\n  .rightBottom3 {\n    -moz-border-radius-bottomright:3px;\n    -webkit-border-bottom-right-radius:3px;\n    border-bottom-right-radius:3px;\n  }\n  .all3 {\n    .leftTop3;\n    .leftBottom3;\n    .rightTop3;\n    .rightBottom3;\n  }\n  .leftTop5 {\n    -moz-border-radius-topleft: 5px;\n    -webkit-border-top-left-radius:5px;\n    border-top-left-radius:5px;\n  }\n  .leftBottom5 {\n    -moz-border-radius-bottomleft:5px;\n    -webkit-border-bottom-left-radius:5px;\n    border-bottom-left-radius:5px;\n  }\n  .rightTop5 {\n    -moz-border-radius-topright: 5px;\n    -webkit-border-top-right-radius:5px;\n    border-top-right-radius:5px;\n  }\n  .rightBottom5 {\n    -moz-border-radius-bottomright:5px;\n    -webkit-border-bottom-right-radius:5px;\n    border-bottom-right-radius:5px;\n  }\n  .all5 {\n    .leftTop5;\n    .leftBottom5;\n    .rightTop5;\n    .rightBottom5\n  }\n  .leftTop10 {\n    -moz-border-radius-topleft:10px;\n    -webkit-border-top-left-radius:10px;\n    border-top-left-radius:10px;\n  }\n  .leftBottom10 {\n    -moz-border-radius-bottomleft: 10px;\n    -webkit-border-bottom-left-radius:10px;\n    border-bottom-left-radius:10px;\n  }\n  .rightTop10 {\n    -moz-border-radius-topright:10px;\n    -webkit-border-top-right-radius:10px;\n    border-top-right-radius:10px;\n  }\n  .rightBottom10 {\n    -moz-border-radius-bottomright: 10px;\n    -webkit-border-bottom-right-radius:10px;\n    border-bottom-right-radius:10px;\n  }\n  .leftSide10 {\n    .leftTop10;\n    .leftBottom10;\n  }\n  .rightSide10 {\n    .rightTop10;\n    .rightBottom10;\n  }\n  .all10 {\n    .leftSide10;\n    .rightSide10;\n  }\n}\n\n.ts-2 {\n  font-size: 1.2em; \n}\n\n.jumbotron {\n  margin: 0 3px;\n}\n\n.hdricon img {\n  height:56px;\n}\n\n.left-spacer-10 {\n  padding-left: 10px;\n}\n.left-margin-10 {\n  margin-left: 10px;\n}\n\n.right-margin-5 {\n  margin-right: 5px;\n}\n.pagination {\n  margin-bottom: 0;\n}\n.paginationWBtn {\n  padding-top: 7px;\n}\n.paginationWBtn2 {\n  padding-top: 0;\n}\n\n.requiredField {\n  color:\"red\";\n  font-size:2em;\n  line-height:20px;\n  vertical-align:middle;\n}\n\n.thf {\n  font-size: .8em;\n}\n.thfc {\n  .thf;\n  text-align: center;\n}\n.thsort {\n  text-decoration: underline;\n  cursor: pointer;\n}\n.tdf {\n  font-size: .7em;\n  line-height: 22px;\n  vertical-align:bottom;\n}\n.docDesc {\n  font-size: 0.9em;\n}\n.tdf-lg-c {\n  text-align: center;\n}\n.tdfc {\n  .tdf;\n  text-align: center;\n}\n.trselectable {\n  cursor: pointer;\n}\n.alertClass\n{\n  color: red;\n}\n\ni {\n    border: solid black;\n    border-width: 0 3px 3px 0;\n    display: inline-block;\n    padding: 3px;\n}\n.up {\n  transform: rotate(-135deg);\n  -webkit-transform: rotate(-135deg);\n}\n.down {\n  transform: rotate(45deg);\n  -webkit-transform: rotate(45deg);\n}\n\n.nav-link {\n  cursor: pointer;\n}\n.navHeader {\n  text-align: center;\n  font-size: 1.3em;\n  font-weight: bold;\n  padding:3px;\n}\n.fixed {\n  position: fixed;\n}\n.relative {\n  position: relative;\n}\n.footer {\n  bottom: 0;\n  left: 0;\n  right: 0;\n  height: 50px;\n  padding: 5px;\n  line-height: 40px;\n  vertical-align: middle;\n  font-size: .7em;\n}\n.fixedfooter {\n  .fixed;\n  .footer;\n  background-color: #e4f2f8;\n}\n.relativefooter {\n  .relative;\n  .footer;\n}\n\n.disabledLabel {\n  font-size: .8em;\n  color: #cccccc;\n}\n.enabledLabel {\n  font-size: .8em;\n}\n\n.radioOpts {\n  margin: 0 .5em 0 1em;\n  padding: 0;\n}\n.rdoLabel {\n  margin: 0;\n}\n\n.tableexport {\n  position: absolute;\n  display:block;\n}\n\n.siteexport {\n  position:relative;\n  top:0;\n  left:0;\n}\n.siteexportexcel {\n  position:relative;\n  top:0;\n  left:150px;\n}\n.paginationSelect {\n  height:30px;\n}\n.msgGroupNone {\n  padding-left: 40px;\n  font-size: .8em;\n}\n\n.selectableColumn{\n  color: #1f60c4;\n  text-decoration: underline;\n  cursor: pointer;\n}\n\n.table-narrow {\n  display: inline-table;\n  width: 250px;\n  margin: 10px;\n}\n.table-lessnarrow {\n  display: inline-table;\n  width: 350px;\n  margin: 10px;\n}\n\n//data grid for doc icons\n\n.rowGrid {\n  display: -ms-webkit-box; /* IE 10 */\n  display: -webkit-box;\n  -ms-flex-wrap: wrap; /* IE 10 */\n  flex-wrap: wrap;\n  padding: 0 4px;\n}\n\n/* Create two equal columns that sits next to each other */\n.columnGrid {\n  -ms-flex: 50%; /* IE 10 */\n  flex: 20%;\n  padding: 0 4px;\n  text-align: center;\n}\n\n.column img {\n  margin-top: 8px;\n  vertical-align: middle;\n}\n\nbutton.desc{\n  background-color: #007bff;\n  padding: 3px 20px;\n  margin: 5px;\n  vertical-align: unset;\n}\n\nimg.docView{\n  border: none;\n  outline: none;\n  padding: 5px 10px;\n  background-color: #f1f1f1;\n  cursor: pointer;\n\n}\n\nimg.docView:hover {\n  background-color: #ddd;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
